import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthGuard } from '$shared/auth/auth-guard';
import { useAuthContext } from '$shared/auth/use-auth-context';
import { useAccessControlGuard } from '$shared/custom-hooks/useAccessControlGuard';

import { useChatBotContext } from '$components/chat-bot/chat-bot-context';
import { CookieInfoButton } from '$components/cookie-policy';
import { FooterLink } from '$components/footer/footer-link';
import { FooterText } from '$components/footer/footer-text';

export function Footer(): ReactElement {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuthContext();
  const { openChat } = useChatBotContext();
  const canUseChat = useAccessControlGuard('VIEW_DEVICE_OVERVIEW');

  return (
    <footer className="flex flex-wrap flex__jc--center m-bottom-xl">
      <FooterLink text={t('footer.usepolicy')} navigationPath="/usepolicy.html" />

      <FooterLink text={t('footer.termsAndConditions')} navigationPath="/terms.html" />

      <FooterLink text={t('footer.privacyPolicy')} navigationPath="/privacypolicy.html" />

      <FooterLink
        text={t('footer.imprint')}
        navigationPath="https://corporate.eppendorf.com/en/imprint/"
      />

      <FooterLink
        text={t('footer.oslibraries')}
        target="_self"
        navigationPath="/oslibraries"
      />

      <AuthGuard>
        <CookieInfoButton />
      </AuthGuard>

      <FooterLink
        text={t('footer.about')}
        navigationPath="https://www.eppendorf.com/en/visionize-lab-suite/"
      />

      {isAuthenticated && canUseChat ? (
        <button
          type="button"
          className="btn-base btn btn--tertiary p-x-s"
          onClick={openChat}
        >
          <FooterText>{t('footer.support')}</FooterText>
        </button>
      ) : (
        <FooterLink
          text={t('footer.support')}
          navigationPath="https://eppendorf.atlassian.net/servicedesk/customer/portals"
        />
      )}
    </footer>
  );
}
